






















































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import {
  AddressInsuranceModel,
  ContactInsuranceModel,
  IndividualModel,
  VForm,
} from '@/app/shared/models';
import { env } from '@/environments';
import Axios from 'axios';
@Component
export default class DialogIndividualComponent extends Vue {
  @Ref() private form!: VForm;

  @Prop(Boolean) readonly value!: boolean;
  @Prop(Object) readonly data!: IndividualModel;

  private individual: IndividualModel = new IndividualModel();

  private stateData: object[] = [];
  private menu = false;
  private newAddress = false;
  private newEmail = false;
  private newPhone = false;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get stateList() {
    return this.refs._.orderBy(this.stateData, 'sigla');
  }
  private get address() {
    return this.refs.modules.policy.individualAddress;
  }
  private get email() {
    return this.refs.modules.policy.individualEmail;
  }
  private get phone() {
    return this.refs.modules.policy.individualPhone;
  }

  private async mounted() {
    this.stateData = await Axios.get<object[]>(
      `${env.statesUri}/localidades/estados`
    ).then(({ data }) => data);
  }
  private onChangeCep() {
    if (this.address.PostalCode)
      Axios.get(`${env.postalCodeUri}/${this.address.PostalCode}/json/`)
        .then(({ data }) => {
          if (!data.erro) {
            this.$set(this.address, 'Name', data.logradouro);
            this.$set(this.address, 'Neighborhood', data.bairro);
            this.$set(this.address, 'City', data.localidade);
            this.$set(this.address, 'SubdivisionCode', data.uf);
          }
        })
        .catch(() => {
          //
        });
  }
  private saveIndividual() {
    if (this.form && !this.form.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }

    if (this.form && this.form.validate())
      this.$emit('submit', [
        this.individual,
        this.newAddress,
        this.newEmail,
        this.newPhone,
      ]);
  }

  @Watch('value')
  private onChangeDialog(value: boolean): void {
    if (value && this.form) {
      this.form.reset();
      this.form.resetValidation();
    }
    if (value) {
      this.individual = this.refs._.clone(this.data);
      const address = this.refs._.clone(
        this.refs._.head(this.individual.Addresses)
      );
      if (address) {
        this.refs.modules.policy.SET_INDIVIDUAL_ADDRESS(address);
        this.newAddress = false;
      } else {
        this.refs.modules.policy.SET_INDIVIDUAL_ADDRESS(
          new AddressInsuranceModel()
        );
        this.newAddress = true;
      }
      const email = this.refs._.clone(
        this.refs.util.findEmail(this.individual.Contacts)
      );
      if (email) {
        this.refs.modules.policy.SET_INDIVIDUAL_EMAIL(email);
        this.newEmail = false;
      } else {
        this.refs.modules.policy.SET_INDIVIDUAL_EMAIL(
          new ContactInsuranceModel(this.refs.enums.ContactType.Email, 'Email')
        );
        this.newEmail = true;
      }
      const cellPhone = this.refs._.clone(
        this.refs.util.findCellphone(this.individual.Contacts)
      );
      if (cellPhone) {
        this.refs.modules.policy.SET_INDIVIDUAL_PHONE(cellPhone);
        this.newPhone = false;
      } else {
        this.refs.modules.policy.SET_INDIVIDUAL_PHONE(
          new ContactInsuranceModel(this.refs.enums.ContactType.Phone, 'Phone')
        );
        this.newPhone = true;
      }
    }
  }
}
